import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 4233.32 4233.32"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M3381.21 3193.16c79.15-94.58 220.01-107.1 314.59-27.95 94.58 79.15 107.11 220.02 27.95 314.6-200.56 239.02-448.75 427.51-724.22 555.86l-18.11 7.38c-271.67 123.65-569.5 190.28-872.7 190.28-581.57 0-1108.8-236.34-1490.26-617.57l-4.47-4.48C234.77 3230.05 0 2704.61 0 2124.82c0-581.57 236.34-1108.58 617.57-1490.04l4.47-4.47c381.23-379.22 906.9-613.99 1486.68-613.99 441.83 0 861.52 139.08 1208.54 381.9 177.53 124.32 336.06 276.14 468.88 450.32V223.59C3786.14 100.17 3886.31 0 4009.73 0c123.43 0 223.6 100.17 223.6 223.59V1480.2c0 123.42-100.17 223.59-223.6 223.59H2753.35c-123.43 0-223.6-100.17-223.6-223.59 0-123.43 100.17-223.6 223.6-223.6h772.52c-120.29-196.76-278.82-364.23-463.51-493.47-272.34-190.51-603.26-299.62-953.64-299.62-456.8 0-870.68 184.24-1170.96 481.62l-4.03 4.03C633 1250.57 447.19 1666.01 447.19 2124.82c0 456.81 184.24 870.46 481.62 1170.75l4.03 4.02c301.4 300.74 717.07 486.55 1175.88 486.55 240.82 0 474.7-51.43 685.99-147.35l16.1-8.28c217.34-101.28 412.98-249.75 570.4-437.35z"
      className="fil0"
    />
  </svg>
);
export default SvgRefresh;
